export const validateChinesePhone = (phone) => {
  const regex = /^1[3-9]\d{9}$/
  return regex.test(phone)
}

export const validateVerificationCode = (code) => {
  const regex = /^\d{6}$/
  return regex.test(code)
}